<template>
    <div class="j-ellipsis-wrap" :style="`--c: '${separator}'`">
        <span class="j-ellipsis-wrap-content">
            <slot />
        </span>
        <el-popover popper-class="j-ellipsis-popover" v-bind="$attrs" v-on="$listeners">
            <div class="j-ellipsis-popover-wrap">
                <div class="j-ellipsis-popover-scroll"><slot /></div>
            </div>
            <span v-show="showEllipsis" slot="reference" class="j-ellipsis-symbol" ><i /><i /><i /></span>
        </el-popover>
    </div>
</template>

<script>
    export default {
        name: "JEllipsis",
        props: {
            separator: { // 分隔符 (只适用于纯文本，无特殊样式的元素，用包裹样式，分隔符将会插入到样式内部)
                type: String,
                default: ''
            },
            ellipsisNum: { // 当数量达到多少个以上时使用缩略详情（大于关系不包含等于）
                type: Number,
                default: 3
            }
        },
        computed: {
            content () {
                return this.$el.firstChild
            }
        },
        data() {
            return {
                showEllipsis: false
            }
        },
        mounted () {
            this.updatedStatus()
        },
        updated () {
            this.updatedStatus()
        },
        methods: {
            updatedStatus () {
                this.$nextTick(() => {
                    this.showEllipsis = this.content.childElementCount > this.ellipsisNum
                })
            }
        }
    }
</script>

<style lang="scss">
    .j-ellipsis-wrap {
        display: flex;
        align-items: center;
        width: 100%;
        .j-ellipsis-wrap-content {
            flex: 1;
            min-width: 20px;
            overflow:hidden; //超出的文本隐藏
            white-space:nowrap; //溢出不换行
            /*text-overflow: ellipsis;*/
            :last-child {
                margin-bottom: 0!important;
                &:after {
                    display: none;
                }
            }
            > * {
                display: inline-block!important;
                margin: 0 5px 0 0!important;
                &:after {
                    content: var(--c, '');
                }
            }
        }
        .j-ellipsis-symbol {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 5px;
            width: 18px;
            height: 18px;
            background: rgba(63,113,221,0.1);
            border-radius: 4px;
            box-sizing: border-box;
            cursor: pointer;
            > i {
                display: inline-block;
                width: 3px;
                height: 3px;
                background: #3F71DD;
                border: 1px solid rgba(63,113,221,0.1);
                border-radius: 50%;
                transform: scale(.5);
            }
        }
    }
    .j-ellipsis-popover-wrap {
        max-height: 100px;
        overflow: auto;
    }
    .j-ellipsis-popover-scroll {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        :last-child {
            margin-bottom: 0!important;
        }
        > * {
            display: inline-block;
            margin: 0 8px 5px 0!important;
        }
    }
    .j-ellipsis-popover {
        min-width: auto!important;
        padding: 8px 5px 8px 12px !important;
    }
</style>
